const formatTime12Hour = (hour24, minute) => {
  const hour12 = hour24 % 12 || 12;
  const period = hour24 >= 12 ? 'PM' : 'AM';
  return `${hour12}:${String(minute).padStart(2, '0')} ${period}`;
};

const START_HOUR = 8;
const END_HOUR = 20;
const SLOT_MINUTES = 30;
const OPTION_COUNT = ((END_HOUR - START_HOUR) * 60) / SLOT_MINUTES + 1;

export const HALF_HOUR_TIME_OPTIONS = Array.from({ length: OPTION_COUNT }, (_, index) => {
  const totalMinutes = START_HOUR * 60 + index * SLOT_MINUTES;
  const hour24 = Math.floor(totalMinutes / 60);
  const minute = totalMinutes % 60;
  const value = `${String(hour24).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
  return { value, label: formatTime12Hour(hour24, minute) };
});
